<template>
  <section class="pay">
    <card>
      <div class="pay__header">
        <p>Buy {{season.name}} to read new strips every weekday until {{season.endsAt}}</p>
      </div>
      <div class="pay__body">
        <payment-form
          :season="season"
          v-model="payment"
          @login="login"
        />
      </div>
    </card>
  </section>
</template>

<script>
import Card from '@/components/Card.vue';
import PaymentForm from './pay/PaymentForm.vue';

export default {
  name: 'Pay',
  props: {
    season: Object,
  },
  components: {
    PaymentForm,
    Card,
  },
  data() {
    return {
      payment: null,
    };
  },
  methods: {
    login({ email, justPaid }) {
      this.$router.push({
        name: 'Login',
        query: {
          ...this.$route.query,
          email,
          justPaid,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pay {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  max-width: 450px;
  margin: 0 auto 60px;
  position: relative;
  @media all and (max-width: 600px) {
    margin: 0;
    padding: 0 10px;
  }
  &__header {
    margin-bottom: 30px;
    color: var(--color-link);
    padding-bottom: 20px;
    border-bottom: solid 1px rgba(0,0,0,0.05);
    p {
      font-weight: 500;
      text-align: center;
    }
  }
  &__image {
    max-height: 200px;
    border-radius: var(--radius);
    overflow: hidden;
    img {
      display: block;
      max-width: 400px;
      width: 100%;
    }
  }
}
</style>
